export const MESSAGE = {
    NO_RECORD_FOUND: 'No Record Found',
}